module.exports = __webpack_public_path__ + "img/mobile_t25.5ab167d0.png";